import { useUser } from '@libs/contexts';
import { GlobalArea } from '@libs/templates/global-area';
import { AuthErrorViewWithBox } from '@libs/templates/template-pages';
import { Outlet } from 'react-router';

// TODO: AUTH-541 要件が確定次第名称管理を行う
function AuthorizedContainer() {
  const { user } = useUser();

  return (
    <>
      <GlobalArea homePath="/system-management/main-menu" isUnderSubsystem={false} />
      {!user || (user.type === 'IAM' && !user.isAdmin) ? <AuthErrorViewWithBox /> : <Outlet />}
    </>
  );
}

export { AuthorizedContainer };
